import { useEffect } from 'react';
import { AuthState, useIdentify } from '@hungryroot/customer';
import { fullPageRedirect } from '@hungryroot/environment';
import { useExperiment } from '@hungryroot/experiments';
import {
  EDIT_DELIVERY_GROCERIES_FOR_YOU_ROUTE,
  EDIT_DELIVERY_GROCERIES_ROUTE,
  EDIT_DELIVERY_RECIPES_FOR_YOU_ROUTE,
  EDIT_DELIVERY_RECIPES_ROUTE,
  MY_HUNGRYROOT_ROUTE,
} from '@hungryroot/routes';

export const useRdpPdpDeepLinkRedirect = (
  param: 'product' | 'recipe',
  value: number
) => {
  const auth = useIdentify();

  const mhrRedesignVariant = useExperiment(171);
  const personalizedSuggestionsVariant = useExperiment(174);

  const userHasCheckedOut = auth.customerData?.did_checkout;

  useEffect(() => {
    if (
      mhrRedesignVariant === undefined ||
      personalizedSuggestionsVariant === undefined
    ) {
      return;
    }

    if (auth.authState === AuthState.isAuthenticated && userHasCheckedOut) {
      let basePath;

      if (mhrRedesignVariant === 1) {
        if (param === 'product') {
          basePath =
            personalizedSuggestionsVariant === 1
              ? EDIT_DELIVERY_GROCERIES_FOR_YOU_ROUTE
              : EDIT_DELIVERY_GROCERIES_ROUTE;
        } else {
          basePath =
            personalizedSuggestionsVariant === 1
              ? EDIT_DELIVERY_RECIPES_FOR_YOU_ROUTE
              : EDIT_DELIVERY_RECIPES_ROUTE;
        }
      } else {
        basePath = MY_HUNGRYROOT_ROUTE;
      }

      fullPageRedirect(`${basePath}?${param}=${value}`);
    }
  }, [
    auth,
    userHasCheckedOut,
    param,
    value,
    mhrRedesignVariant,
    personalizedSuggestionsVariant,
  ]);

  return {
    loading:
      mhrRedesignVariant === undefined ||
      personalizedSuggestionsVariant === undefined ||
      auth.authState === AuthState.isLoading ||
      (auth.authState === AuthState.isAuthenticated && userHasCheckedOut),
  };
};
